var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "44",
        height: "45",
        viewBox: "0 0 44 45",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M21.9512 45C34.0745 45 43.9024 34.9264 43.9024 22.5C43.9024 10.0736 34.0745 0 21.9512 0C9.8279 0 0 10.0736 0 22.5C0 34.9264 9.8279 45 21.9512 45Z",
          fill: "url(#paint0_linear_86_287)",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M9.32181 21.8884C15.721 19.0306 19.9882 17.1466 22.1232 16.2364C28.2193 13.6375 29.4861 13.186 30.3116 13.1711C30.4933 13.1678 30.8993 13.2139 31.1623 13.4327C31.5524 13.7572 31.5546 14.4616 31.5113 14.9277C31.1809 18.4855 29.7515 27.1193 29.0243 31.1041C28.7166 32.7902 28.1107 33.3556 27.5242 33.4109C26.2495 33.5311 25.2815 32.5473 24.0468 31.7178C22.1148 30.4197 21.0234 29.6116 19.148 28.3449C16.9807 26.881 18.3857 26.0765 19.6208 24.7615C19.9441 24.4175 25.5606 19.181 25.6693 18.706C25.6829 18.6466 25.6955 18.4251 25.5672 18.3082C25.4388 18.1913 25.2494 18.2312 25.1127 18.263C24.9189 18.3081 21.8326 20.3991 15.8536 24.5359C14.9775 25.1526 14.184 25.453 13.4731 25.4372C12.6893 25.4199 11.1817 24.983 10.0609 24.6096C8.68617 24.1516 7.59358 23.9094 7.68876 23.1315C7.73832 22.7263 8.28265 22.3119 9.32181 21.8884Z",
          fill: "white",
        },
      }),
      _vm._v(" "),
      _c(
        "defs",
        [
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint0_linear_86_287",
                x1: "21.9512",
                y1: "0",
                x2: "21.9512",
                y2: "44.6484",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#2AABEE" } }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#229ED9" } }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }